import { Address, IAddressDto } from "@/models/Address";
import { IHttpService } from "frontend-core";
import { IAddressService } from "@/modules/Segmentation/services/IAddressService";
import { inject, injectable } from "tsyringe";
import { IAppService } from "@/services/IAppService";
import { IApiLegacyResponse } from "frontend-core/dist/services/implementations/HttpService";
import { IKladrItemDto, KladrItem } from "@/models/KladrItem";

@injectable()
export class AddressService implements IAddressService {
  constructor(
    @inject("IAppService")
    private readonly appService: IAppService,
    @inject("IHttpService")
    private readonly httpService: IHttpService,
  ) {}

  async addKladrs(addresses: Address[]): Promise<void> {
    await this.httpService.api.post("/kladr", {
      data: addresses.map(
        a =>
          new KladrItem({
            code: a.kladr,
            title: a.presentation,
          }),
      ),
    });
  }

  async getAddressesFromKladrs(kladrs: string[] | null): Promise<Address[]> {
    let result: Address[] = [];

    if (kladrs === null || kladrs.length === 0) {
      return result;
    }

    await this.httpService.api
      .get("/kladr?" + kladrs.map(code => `codes[]=${code}`).join("&"))
      .then(object => {
        console.log(object.data.data);

        result = result.concat(
          object.data.data.map(
            (i: IKladrItemDto) => new Address(i.title, i.code),
          ),
        );
      })
      .catch(() => {
        kladrs.map(code =>
          result.push(new Address(`Не найдено (${code})`, code)),
        );
      });

    console.log("result", result);

    return result;
  }

  async search(searchStr: string): Promise<Address[]> {
    const array: Address[] = [];

    await this.httpService.api
      .get("/b2b/search/dadata/address?is_limitation=Y&q=" + searchStr, {
        baseURL: this.appService.legacyApiDomain,
      })
      .then((data: IApiLegacyResponse<{ suggestions: IAddressDto[] }>) => {
        if (data.data.meta.success) {
          array.push(...data.data.data.suggestions?.map(i => new Address(i)));
        }
      });

    return array;
  }
}
